import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { FOOD_PARTNER_ORDER_PATH } from '../../core/constants';

export const sendFoodPartnerOrderAction = createAsyncThunk(
    'inventory/sendFoodPartnerOrderAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ FOOD_PARTNER_ORDER_PATH }/${ data.id }/send?generateLabels=${ data.generateLabels }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const sendFoodPartnerOrderSlice = createSlice({
    name: 'sendFoodPartnerOrderSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(sendFoodPartnerOrderAction.pending, () => STATE__API__STARTED);
        builder.addCase(sendFoodPartnerOrderAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(sendFoodPartnerOrderAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const sendFoodPartnerOrderState = (state) => state.inventory.sendFoodPartnerOrder;
export default sendFoodPartnerOrderSlice.reducer;
